<template lang="pug">
.displacement-image-wrapper(ref="canvasWrapper")
    #inject-displacement-image.displacement-injector(ref="inject")
</template>

<script>
import * as PIXI from "pixi.js";
import { TweenMax, Power2, TimelineLite } from "gsap";
export default {
    name: "displacement-image",
    data: function () {
        return {
            app: null,
            displacementSprite: null,
            displacementFilter: null,
            background1Sprite: null,
            background2Sprite: null,
            loader: null,
        };
    },
    props: {
        image1: {
            type: String,
            required: true,
            default: "",
        },
        image2: {
            type: String,
            required: true,
            default: "",
        },
        displacement: {
            type: String,
            required: true,
            default: "",
        },
        aspectRatio: {
            type: String,
            required: true,
            validator: (val) => {
                return ["16:9", "1:1", "4:3"].indexOf(val) != -1;
            },
        },
        width: {
            type: Number,
            required: true,
            default: 512,
        },
        shiftFactor: {
            type: Number,
            required: false,
            default: 0.05,
        },
    },
    mounted: function () {
        this.createRenderer();
    },
    methods: {
        wrapperHeight: function () {
            let height = 0;
            if (this.aspectRatio == "16:9") {
                height = this.imageWidth / (16 / 9);
            } else if (this.aspectRatio == "1:1") {
                height = this.imageWidth;
            } else if (this.aspectRatio == "4:3") {
                height = this.imageWidth / (4 / 3);
            } else height = this.imageWidth;

            return height;
        },
        createRenderer() {
            this.app = new PIXI.Application({
                autoStart: true,
                width: this.width,
                height: this.width,
            });
            this.$refs.inject.appendChild(this.app.view);
            this.app.stage.interactive = true;
            // load assets
            this.loadAssets();
        },
        loadAssets() {
            //
            this.loader = new PIXI.Loader();

            this.loader.add("bg1", this.image1);

            this.loader.add("bg2", this.image2);

            this.loader.add("displacement", this.displacement);
            this.loader.load(this.init);
        },
        createDisplacement() {
            let dSprite = new PIXI.Sprite(
                this.loader.resources["displacement"].texture
            );
            dSprite.width = this.app.renderer.width * 1.5;
            dSprite.height = this.app.renderer.height;
            dSprite.x = 0;
            dSprite.y = 0;
            this.displacementSprite = dSprite;
            this.app.stage.addChild(this.displacementSprite);

            let dFilter = new PIXI.filters.DisplacementFilter(dSprite);
            this.app.stage.filters = [dFilter];

            this.displacementFilter = dFilter;

            dFilter.scale.x = 0;
            dFilter.scale.y = 0;
        },
        createBackgrounds() {
            let width = this.app.renderer.width;
            let height = this.app.renderer.height;

            let bg1 = new PIXI.Sprite(this.loader.resources["bg1"].texture);
            bg1.width = width * 1.2;
            bg1.height = height * 1.2;
            bg1.anchor.set(0.5);
            bg1.x = width / 2;
            bg1.y = height / 2;
            this.app.stage.addChild(bg1);
            this.background1Sprite = bg1;

            let bg2 = new PIXI.Sprite(this.loader.resources["bg2"].texture);
            bg2.width = width * 1.2;
            bg2.height = height * 1.2;
            bg2.anchor.set(0.5);
            bg2.x = width / 2;
            bg2.y = height / 2;
            bg2.alpha = 0;
            this.app.stage.addChild(bg2);
            this.background2Sprite = bg2;
        },
        bindEvents() {
            let stage = this.app.stage;
            let appWidth = this.app.renderer.width;
            let moveFactor = appWidth * this.shiftFactor;
            this.background1Sprite.x = this.app.renderer.width / 2 + moveFactor;
            this.background2Sprite.x = this.app.renderer.width / 2 + moveFactor;

            stage.mouseover = stage.pointerover = () => {
                let newScale = appWidth;
                TweenMax.to(this.background2Sprite, 0.4, {
                    alpha: 1,
                    x: appWidth / 2 - moveFactor,
                    ease: Power2,
                    delay: 0.1,
                });
                TweenMax.to(this.background1Sprite, 0.4, {
                    x: appWidth / 2 - moveFactor,
                    ease: Power2,
                    delay: 0.1,
                });
                TweenMax.to(this.displacementSprite, 0.4, {
                    width: newScale,
                    ease: Power2,
                });
                let distortTimeline = new TimelineLite();
                distortTimeline.to(this.displacementFilter.scale, 0.2, {
                    x: 100,
                    y: 100,
                    ease: Power2,
                });
                distortTimeline.to(this.displacementFilter.scale, 0.2, {
                    x: 0,
                    y: 0,
                    ease: Power2,
                });
            };

            stage.mouseout = stage.pointerout = () => {
                let oldScale = appWidth * 1.5;
                TweenMax.to(this.background2Sprite, 0.4, {
                    alpha: 0,
                    x: appWidth / 2 + moveFactor,
                    ease: Power2,
                    delay: 0.1,
                });
                TweenMax.to(this.background1Sprite, 0.4, {
                    x: appWidth / 2 + moveFactor,
                    ease: Power2,
                    delay: 0.1,
                });
                TweenMax.to(this.displacementSprite, 0.4, {
                    width: oldScale,
                    ease: Power2,
                });
                let distortTimeline = new TimelineLite();
                distortTimeline.to(this.displacementFilter.scale, 0.2, {
                    x: 100,
                    y: 100,
                    ease: Power2,
                });
                distortTimeline.to(this.displacementFilter.scale, 0.2, {
                    x: 0,
                    y: 0,
                    ease: Power2,
                });
            };
        },
        init() {
            this.createDisplacement();
            this.createBackgrounds();
            this.bindEvents();

            this.app.view.classList.add("distortion-image-canvas");
        },
    },
};
</script>

<style lang="scss">
.distortion-image-canvas {
    width: 100% !important;
    height: auto !important;
}
</style>